// extracted by mini-css-extract-plugin
export default {"container":"CookiesBanner_container__fK9xo","accept":"CookiesBanner_accept__SWzPt"};